import { useState } from "react";
import { useTranslation } from "react-i18next";
import useUiContext from "@/custolink-hooks/useUiContext";
import SignInForm from "@/custolink-views/asset_frontend/account/SignInForm";
import SignupForm from "@/custolink-views/asset_frontend/account/SignupForm";
import { LanguageSelect } from "@/custolink-views/asset_frontend/ui/LanguageSelect";
import { RdaLanguageSelect } from "@/custolink-views/asset_frontend/redesigns/RdaLanguageSelect";
import { useAssetFrontendDesign } from "@/custolink-views/asset_frontend/redesigns/assetFrontendDesign";
import {
  InfoNote,
  PrimaryButton,
  SecondaryButton,
} from "@/custolink-views/asset_frontend/redesigns/formKit";

// Shared with the classic design (AssetViewClassic/AssetFrontendHome's AccountDrawer renders
// this same component), so the language picker follows the asset-frontend switch; the rest
// of this file was already redesigned unconditionally by an earlier batch.
export default function PresentOptionsPart(p: {
  useThisFeatureAlert: boolean;
}) {
  const uic = useUiContext();
  const [mode, setMode] = useState<"signin" | "signup" | null>(null);
  const { t } = useTranslation();
  const newDesign = useAssetFrontendDesign();

  if (mode == "signin") {
    return (
      <div>
        <h2 className="mb-5 text-2xl font-semibold tracking-[-0.02em]">
          {t("account.signIn.title")}
        </h2>
        <SignInForm back={() => setMode(null)} />
      </div>
    );
  }

  if (mode == "signup") {
    return (
      <div>
        <h2 className="mb-5 text-2xl font-semibold tracking-[-0.02em]">
          {t("account.signUp.title")}
        </h2>
        <SignupForm back={() => setMode(null)} />
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {p.useThisFeatureAlert ? (
        <InfoNote>{t("account.featureAccess.requiresSignIn")}</InfoNote>
      ) : (
        <div>
          <h2 className="text-2xl font-semibold tracking-[-0.02em]">
            {t("account.welcome")}
          </h2>
          <p className="mt-2 text-sm text-[var(--rda-muted)]">
            {t("account.signIn.prompt")}
          </p>
        </div>
      )}

      <div className="space-y-3 pt-2">
        <PrimaryButton type="button" onClick={() => setMode("signin")}>
          {t("account.signIn.title")}
        </PrimaryButton>
        <p className="text-center text-sm text-[var(--rda-muted)]">
          {t("account.signIn.doNotHaveAccountQuestion")}
        </p>
        <SecondaryButton
          className="w-full"
          type="button"
          onClick={() => setMode("signup")}
        >
          {t("account.signUp.title")}
        </SecondaryButton>
      </div>

      {uic.organisationContext.assetFrontendi18nEnabled && (
        <div className="border-t border-[color:var(--rda-line)] pt-4">
          <h6 className="text-[11px] font-bold uppercase tracking-[0.12em] text-[var(--rda-muted)]">
            {t("account.info.language")}
          </h6>
          <div className="mt-2">
            {newDesign ? <RdaLanguageSelect /> : <LanguageSelect />}
          </div>
        </div>
      )}
    </div>
  );
}
